"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitBy = void 0;
const filter_1 = require("./filter");
exports.omitBy = (iterable, iteratee) => filter_1.filter(iterable, (value) => !iteratee(value));
//# sourceMappingURL=omit-by.js.map